import { FC } from 'react'
import { Icon } from '@iconify/react'
import { useModal } from '@ebay/nice-modal-react'
import { BooleanParam, useQueryParam } from 'use-query-params'

import { useGlobalState } from '@pepper/ui'

import AiSuggestedKeywords from 'assets/images/content-ideas/ai-keywords.png'
import ImportKeywords from 'assets/images/content-ideas/import-keywords.png'

import EmptyStateCard from 'components/EmptyStateCard'

import s from './EmptyState.module.css'

type Props = {
  onImportKeywords: () => void
  onResearchKeywords: () => void
  isDomainRemoved?: boolean
  isDomainNotLinked?: boolean
}

export const EmptyState: FC<Props> = ({
  onImportKeywords,
  onResearchKeywords,
  isDomainRemoved,
  isDomainNotLinked,
}) => {
  const { permissions } = useGlobalState()
  const { show } = useModal('buy-cmp')
  const [_, setOpenLinkDomainModal] = useQueryParam('link_domain', BooleanParam)

  const hasKeywordsPermission = permissions?.keywords

  const handleClick = (onClick: () => void) => {
    if (!hasKeywordsPermission) {
      show({ id: 'keywords' })
    } else if (isDomainNotLinked && hasKeywordsPermission) {
      setOpenLinkDomainModal(true)
    } else {
      onClick()
    }
  }

  return (
    <div className={s.wrapper}>
      <h4 className={s.title}>Your keywords list appear here..</h4>
      {isDomainRemoved ? (
        <p className={s.error}>
          <Icon icon="lucide:info" />
          Domain associated with this project has been removed
        </p>
      ) : (
        <p className={s.subtitle}>
          Every great content journey begins with a single word. Let&apos;s get
          started! 👇
        </p>
      )}
      <div className={s.cardsWrapper}>
        <EmptyStateCard
          onClick={() => handleClick(onResearchKeywords)}
          alt="AI suggested topics"
          image={AiSuggestedKeywords}
          title="Discover Keywords"
          description="Dive into a sea of content ideas curated for you, or create your very own! 💡"
          icon={<Icon width={22} icon="heroicons:sparkles-solid" />}
          disabled={isDomainRemoved}
          dataId="discover-keywords-card"
        />

        <EmptyStateCard
          onClick={() => handleClick(onImportKeywords)}
          alt="keywords import"
          image={ImportKeywords}
          title="Import your Keywords"
          description="Have a list ready? 📋 Create keywords, SEO briefs, and start writing!"
          icon={<Icon icon="uil:file-upload-alt" width={22} />}
          disabled={isDomainRemoved}
        />
      </div>
    </div>
  )
}
